const defaultEndpoint = 'https://www.mapapal.com/Com/Com.aspx'
export const USER_IMAGE_UPDATED_EVENT = 'mapapal:user-image-updated'
const imageVersionStoragePrefix = 'mapapal.userImageVersion.'

function imageVersionStorageKey(username: string): string {
  return `${imageVersionStoragePrefix}${username.trim().toLocaleLowerCase()}`
}

export function buildUserImageUrl(username: string, baseUrl = defaultEndpoint): string {
  return `${baseUrl}?mobweb&sid=&f=user_image&user=${encodeURIComponent(username)}`
}

export function getUserImageVersion(username: string): string | undefined {
  try {
    return window.localStorage.getItem(imageVersionStorageKey(username)) ?? undefined
  } catch {
    return undefined
  }
}

export function notifyUserImageUpdated(username: string): void {
  const version = Date.now().toString()
  try {
    window.localStorage.setItem(imageVersionStorageKey(username), version)
  } catch {
    // The current page can still refresh through the event when storage is unavailable.
  }
  window.dispatchEvent(new CustomEvent(USER_IMAGE_UPDATED_EVENT, { detail: username }))
}
